import { CalendarIcon, BookIcon, Pane, Strong, Text } from "evergreen-ui";
import React from "react";
import { Doughnut } from "react-chartjs-3";

const DoughnutGraphContent = ({ dcObject }) => {
  return (
      <Pane
        display="flex"
        width={"full"}
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        flexGrow="2"
      >
        <Pane
          display="flex"
          justifyContent="space-between"
          flexDirection="row"
          width="100%"
        >
          <Pane
            display="flex"
            justifyContent="space-between"
            flexDirection="row"
          >
            <Pane height={20} width={20} background={"#00B562"} borderRadius={6}></Pane>
            <Text marginLeft={10}>Online</Text>
          </Pane>
          <Pane
            display="flex"
            justifyContent="end"
            flexDirection="row"
            width={"100%"}
            alignItems="end"
          >
            <Strong>{ dcObject.online }</Strong>
          </Pane>
        </Pane>
        <Pane
          display="flex"
          justifyContent="space-between"
          flexDirection="row"
          width={"100%"}
          marginTop={16}
        >
          <Pane
            display="flex"
            justifyContent="space-between"
            flexDirection="row"
          >
            <Pane height={20} width={20} background={"#0F4D88"} borderRadius={6}></Pane>
            <Text marginLeft={10}>Offline</Text>
          </Pane>
          <Pane
            display="flex"
            justifyContent="end"
            flexDirection="row"
            width={"100%"}
            alignItems="end"
          >
            <Strong>{ dcObject.offline }</Strong>
          </Pane>
        </Pane>
      </Pane>
  )
}

const DoughnutFallbackContent = ({ title }) => {
  return (
    <Pane display="flex" width="full" alignItems="center" justifyContent="center">
      <Pane>
        <Pane color="#0F4D88" lineHeight={2} fontWeight="bold" fontSize={16}>
          No { title }
        </Pane>
        <Pane fontSize={12}>
          There are no { title } for selected period.
        </Pane>
      </Pane>
    </Pane>
  )
}

function DoughnutChart(props) { 
  const totalBookingCount = props.dcObject.online + props.dcObject.offline;
  const dataBgColorValues = {
    data: [props.dcObject.online, props.dcObject.offline],
    backgroundColor: ["#00B562", "#0F4D88"]
  }

  if (props.dcObject.online + props.dcObject.offline === 0) {
    dataBgColorValues.data = [100];
    dataBgColorValues.backgroundColor = ["#d3d3d3"]
  }

  const data = {
    datasets: [
      {
        hover: false,
        data: dataBgColorValues.data,
        backgroundColor: dataBgColorValues.backgroundColor, 
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: { enabled: false },
  }; 

  const plugins = [
    
  ];
  return (
    <Pane
      display="flex"
      background="#f1f3f2"
      flexDirection="column"
      justifyContent="space-between"
      borderRadius={"20px"}
      width="100%"
      padding="16px"
      paddingTop="20px"
    >
      <Pane
        display={"flex"}
        flexDirection={"row"}
        justifyContent="space-between"
        alignItems="center"
      >
        <Pane
          display={"flex"}
          flexDirection={"row"}
          justifyContent="space-between"
          alignItems="center"
        >
          {
            props.title === "bookings" ?
              <Pane height="32px" width="32px" borderRadius="50%" background="#fff"
                    display="flex" justifyContent="center" alignItems="center">
                <BookIcon color="selected" size={16} />
              </Pane>
              :
              <Pane height="32px" width="32px" borderRadius="50%" background="#fff"
                    display="flex" justifyContent="center" alignItems="center">
                <CalendarIcon color="selected" size={16} />
              </Pane>
          }
          <Text marginLeft={20} textTransform="capitalize">No. of {props.title}</Text>
        </Pane>
        <Strong fontSize={"20px"} color="#0f4d88" letterSpacing=".25px">
          {props.dcObject.online + props.dcObject.offline}
        </Strong>
      </Pane>
      <Pane
        display="flex"
        flexDirection="row"
        alignItems="center"
        marginTop="20px"
        gap="36px"
      > 
        <Pane
          display="flex"
          flexDirection="row"
          justifyContent="start"
          alignItems="center"
          width="125px"
          height="125px"
          position="relative"
        >
          <Pane position="absolute" top="50%" left="50%" fontWeight={600} transform="translate(-50%, -20%)">
            {props.dcObject.online + props.dcObject.offline}
          </Pane>
          <Doughnut options={options} plugins={plugins} data={data} />
        </Pane>
        {
          props.dcObject.online + props.dcObject.offline === 0 ? 
            <DoughnutFallbackContent title={ props.title }/>
            :
            <DoughnutGraphContent dcObject={props.dcObject }/>
        }
      </Pane>
    </Pane>
  );
}

export default DoughnutChart;
